import React from 'react';
import ReactDom from 'react-dom';
import { Button, Image, Typography } from 'lib/components';
import classes from './index.module.scss';

/**
 * Props interface for the UnvoidInvoiceModal component
 */
interface Props {
	/** Controls whether the modal is visible */
	isOpen: boolean;
	/** The original reason for voiding the invoice */
	reason?: string;
	/** Callback function when modal is closed */
	onClose: () => any;
	/** Callback function when unvoid action is confirmed */
	onUnvoidInvoice: () => any;
}

/**
 * UnvoidInvoiceModal component
 * Modal dialog for confirming unvoiding an invoice
 * Displays the original void reason and confirmation buttons
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element | null} - Rendered component or null if not open
 */
const UnvoidInvoiceModal = ({ isOpen, onClose, reason, onUnvoidInvoice }: Props) => {
	// Don't render anything if modal is not open
	if (!isOpen) {
		return null;
	}

	// Use React Portal to render the modal outside the normal DOM hierarchy
	return ReactDom.createPortal(
		<div className={classes['modal']}>
			<div className={classes['modal-content']}>
				<div className={classes['modal-items']}>
					{/* Display the original void reason */}
					<div>
						<div className={classes['modal-title']}>
							<Image src="icDangerAlertPrimary" />
							<Typography variant="subheading1" weight="bold">
								Reasoning for Void Invoice:
							</Typography>
						</div>
						<Typography>{reason}</Typography>
					</div>
					{/* Footer with action buttons */}
					<div className={classes['modal-unvoid-footer']}>
						{/* Cancel button */}
						<Button
							style={{
								justifyContent: 'center',
							}}
							variant="standard"
							color="gray"
							sizing="small"
							title="Cancel"
							onClick={onClose}
						/>
						{/* Confirm button */}
						<Button
							variant="standard"
							color="primary"
							title="Unvoid Invoice"
							style={{
								justifyContent: 'center',
							}}
							onClick={() => {
								onUnvoidInvoice();
								onClose();
							}}
						/>
					</div>
				</div>
			</div>
		</div>,
		document.getElementById('portal') as HTMLElement
	);
};

export default UnvoidInvoiceModal;
